const iFrameSrc =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.8853934323074!2d73.01963211546207!3d19.024771158523272!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c3c488b5bd51%3A0x452d2a4a2f9375a0!2sV.%20A%20Law%20Offices!5e0!3m2!1sen!2sin!4v1645031603723!5m2!1sen!2sin";

const MapComponent = () => {
  return (
    <iframe
      src={iFrameSrc}
      width={"100%"}
      style={{ maxWidth: "1260px" }}
      height={500}
    />
    // </div>
  );
};

export default MapComponent;
